import { render, staticRenderFns } from "./indexnew.vue?vue&type=template&id=91af2e94&scoped=true&"
import script from "./indexnew.vue?vue&type=script&lang=js&"
export * from "./indexnew.vue?vue&type=script&lang=js&"
import style0 from "./indexnew.vue?vue&type=style&index=0&id=91af2e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91af2e94",
  null
  
)

export default component.exports